<template>
  <!-- <CustomAlert ref="customAlert" /> -->
<router-view/>
</template>

<script>
// import User from './components/user.vue'
import { useStore } from 'vuex';
import { onMounted } from 'vue';
export default {
  // name: 'App',
  // components: {
  //   // User
  // },
  // mounted(){
    
  // }
  setup() {
    const store = useStore();

    onMounted(() => {
      // 每次完整加载应用时都调一次
      store.dispatch('fetchUser');

      const navEntries = performance.getEntriesByType('navigation');
      const navType = navEntries[0]?.type;
      const legacyType = performance.navigation?.type;

      if (navType === 'reload' || legacyType === performance.navigation.TYPE_RELOAD) {
        console.log('🔁 整个应用是通过刷新加载的');
        // 这里可以做一些「刷新特有」的逻辑（例如清除某些缓存）
      }
    });

    return {};
  }
}
</script>

<style>
 
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background: red; */
  width: 100%;
  /* margin-top: 60px; */

}

</style>
